function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgaStack = function SvgaStack(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Stack' : _ref$title,
      rest = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, rest, {
    viewBox: "0 0 52 48"
  }), React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    transform: "translate(0.000000, 1.000000)",
    stroke: "#8C8C8C"
  }, React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "23.0055991 41.6573348 0.0940649496 26.8756999 23.0055991 12.0940649 45.9171333 26.8756999"
  }), React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "23.0055991 35.7446809 0.0940649496 20.9630459 23.0055991 6.18141097 45.9171333 20.9630459"
  }), React.createElement("polygon", {
    fill: "#DDDDDD",
    points: "0.0940649496 15.0503919 23.0055991 0.268756999 45.9171333 15.0503919 23.0055991 29.8320269"
  }))));
};

SvgaStack = pure(SvgaStack);
SvgaStack.displayName = 'SvgaStack';
export default SvgaStack;